var _rect, _circle, _circle2, _rect2, _path, _path2, _rect3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayerManager(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 144,
    height: 104,
    rx: 12,
    fill: "#E8F3FF",
    stroke: "#B8D4FF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 56,
    r: 18,
    fill: "#6CA6FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 52,
    r: 10,
    fill: "#F4F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 76,
    width: 40,
    height: 18,
    rx: 8,
    fill: "#6CA6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 50H130",
    stroke: "#6CA6FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64H118",
    stroke: "#6CA6FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 78,
    width: 34,
    height: 10,
    rx: 5,
    fill: "#FFCE73"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 109,
    y: 86,
    fill: "#25416A",
    fontFamily: "Inter, Arial",
    fontSize: 8,
    fontWeight: 700,
    textAnchor: "middle"
  }, "ROSTER")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerManager);
export default __webpack_public_path__ + "static/media/player-manager.b05078f1de05ba7563d8e199f07d3654.svg";
export { ForwardRef as ReactComponent };